export const environment={
	appName: 'frag-camera',
	appTitle: 'Strayos Netra',
	production: false,
	backendUrl: '',
	sentryUrl:'',
	name:'',
	showDarkMode:false,
	showVideoTab:false,
	signalingServerUrl:'',
	azureNetraMediaUrl: 'https://netramedia.blob.core.windows.net',
	azureContainerName: 'uploads',
	uploadsStorageFolder: '',
	fileStorageSas: '?sv=2025-07-05&spr=https&st=2026-05-14T13%3A09%3A32Z&se=2027-06-15T13%3A09%3A00Z&sr=c&sp=r&sig=4IsTv01K5BTtiqxfmYvo4ToG5DB4t7U51AB3DKwq8q4%3D',
	googleMapsAPIKey:'AIzaSyDoMibEPR0ubzMiH0uHa4P_-pDrYGXIF6s',
	vendor: 'Strayos',
	zohoDesk: {
		departmentId: '940019000002400437',
		layoutId: '940019000002454826',
		widgetId: '940019000002477005',
		orgId: '841237884',
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
